import axios from 'axios';
import { GOOGLE_API_KEY } from '../config';

export default async (latitude, longitude) =>
  await axios.get(
    `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}
    &language=en&key=${GOOGLE_API_KEY}`
  );
